<link href="https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/3.3.7/css/bootstrap.min.css" rel="stylesheet" />
<template>
  <div id="app">
    <b-card header="<i class='fa fa-file-o'></i> Detil Pengajuan">
      <loading :active.sync="isLoading" :is-full-page="false"></loading>
      <div class="panel panel-sm">
        <div class="panel-heading">
          <h4>Upload CSV Laporan</h4>
        </div>
        <div class="form-group row">
          <div class="col-8">
            <input type="file" id="csv_file" name="csv_file" class="form-control" @change="upload($event)">
          </div>
          <div class="col-4">
            <!-- <a v-if="jns_laporan != ''" :href="'http://localhost/backper/public/api/dllaporan/' + jns_laporan"><button @click="" type="button" class="btn btn-warning" title="Format Laporan"><i class="fa fa-download" ></i> Download Format</button></a> -->
            <a v-if="jns_laporan != ''" :href="$http.options.root + '/dllaporan/' + jns_laporan"><button @click=""
                type="button" class="btn btn-success" title="Format Laporan"><i class="fa fa-download"></i> Download
                Format</button></a>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-8">

            <b-form-fieldset label="Jenis Laporan">
              <select title="Jenis Dokumen Yang Diajukan" class="form-control" v-model="jns_laporan">
                <option value="">Pilih Laporan</option>
                <option value=1>Laporan Tempat Penimbunan Sementara</option>
                <option value=2>Laporan Bongkar Kawasan Pabean</option>
                <option value=3>Laporan BKC</option>
                <option value=4>Rekonsiliasi Outward Manifes - Barkir</option>
              </select>
            </b-form-fieldset>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-4">
            <b-form-fieldset label="Tanggal Awal Laporan">
              <b-form-input title="Tanggal Permohonan Izin" name="Tgl Akhir" v-model="tgl_awal" type="date">
              </b-form-input>
            </b-form-fieldset>
          </div>
          <div class="col-4">

            <b-form-fieldset label="Tanggal Akhir Laporan">
              <b-form-input title="Tanggal Permohonan Izin" name="Tgl Akhir" v-model="tgl_akhir" type="date">
              </b-form-input>
            </b-form-fieldset>
          </div>

        </div>

        <div v-if="jns_laporan == '1' || jns_laporan == '2'" class="col-12"
          style="height:300px;max-width:1400px;overflow-y:scroll;overflow-x:scroll;">
          <table class="table table-bordered table-hover table-sm" v-if="parse_csv" border="1">
            <thead>
              <tr>
                <th v-for="key in parse_header" @click="sortBy(key)" :class="{ active: sortKey == key }">
                  {{ key | capitalize }}
                  <span class="arrow" :class="sortOrders[key] > 0 ? 'asc' : 'dsc'">
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="csv in parse_csv">
                <td v-for="key in parse_header">
                  {{ csv[key] }}
                </td>
              </tr>
            </tbody>

          </table>
        </div>
        <div class="pull-right">
          <br><button @click="swalreport" type="button" class="btn btn-success" title="Kirim Laporan"
            :disabled="!isComplete"><i class="fa fa-send"></i> Kirim</button>
        </div>

      </div>
    </b-card>
  </div>
</template>


<script>
import swal from 'sweetalert'
export default {
  data () {
    return {
      laporan: null,
      isLoading: false,
      loading: true,
      channel_name: '',
      channel_fields: [],
      channel_entries: [],
      file: '',
      fileSize: 0,
      fileExt: '',
      fileName: '',
      fileValid: '',
      jns_laporan: '',
      parse_header: [],
      parse_csv: [],
      sortOrders: {},
      sortKey: '',
      tgl_awal: null,
      tgl_akhir: null,
      tps: this.$store.getters['auth/user']['ppjk']
    }
  },
  filters: {
    capitalize: function (str) {
      return str.toUpperCase()
    }
  },
  computed: {
    isComplete () {
      return this.laporan && this.tgl_awal && this.jns_laporan && this.loading
    }
  },
  methods: {
    simpanlaporan () {
      // this.$Progress.start()
      this.isLoading = true
      var datalaporan = {
        user: this.$store.getters['auth/user']['username'],
        npwp: this.$store.getters['auth/user']['npwp'],
        id_gudang: this.laporan[0].id_gudang,
        bulan: '01',
        jns_laporan: this.jns_laporan,
        laporan: this.laporan,
        file: this.file,
        ext: this.fileExt,
        tgl_awal: this.tgl_awal,
        tgl_akhir: this.tgl_akhir
      }
      this.$http.post('laporan', datalaporan)
        .then(response => {
          swal(response.data.status, response.data.message, response.data.status)
          this.loading = true
          this.isLoading = false
          swal(response.data.status, response.data.message, response.data.status).then(() => {
            if (response.data.status === 'success') {
              this.$router.push('/pengajuan/browseupload')
            }
          })
          // if (response.data.status === 'success') {
          //   this.$router.push('/pengajuan/upload')
          // }
        })
      // this.$Progress.finish()
    },
    swalreport () {
      swal({
        title: 'Kirim Laporan?',
        text: 'Anda yakin mengirimkan laporan?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      })
        .then((value) => {
          switch (value) {
            case 'Yes':
              this.simpanlaporan()
          }
        })
    },
    sortBy: function (key) {
      var vm = this
      vm.sortKey = key
      vm.sortOrders[key] = vm.sortOrders[key] * -1
    },
    csvJSON (csv) {
      var vm = this
      var lines = csv.split('\n')
      var result = []
      var headers = lines[0].split(';')
      vm.parse_header = lines[0].split(';')
      lines[0].split(';').forEach(function (key) {
        vm.sortOrders[key] = 1
      })

      lines.map(function (line, indexLine) {
        if (indexLine < 1) return // Jump header line

        var obj = {}
        var currentline = line.split(';')

        headers.map(function (header, indexHeader) {
          obj[header] = currentline[indexHeader]
        })

        result.push(obj)
      })

      result.pop() // remove the last item because undefined values

      return result // JavaScript object
    },
    loadCSV (e) {
      var vm = this
      if (window.FileReader) {
        var reader = new FileReader()
        reader.readAsText(e.target.files[0])
        // Handle errors load
        reader.onload = function (event) {
          var csv = event.target.result
          vm.parse_csv = vm.csvJSON(csv)
          vm.laporan = vm.csvJSON(csv)
        }
        reader.onerror = function (evt) {
          if (evt.target.error.name === 'NotReadableError') {
            swal('Cannot read file !')
          }
        }
      } else {
        swal('FileReader are not supported in this browser.')
      }
    },
    fileChanged (e) {
      this.$Progress.start()
      var fileReader = new FileReader()
      fileReader.readAsDataURL(e.target.files[0])
      this.fileSize = e.target.files[0].size / 1024
      this.fileExt = e.target.files[0].name.substr((e.target.files[0].name.lastIndexOf('.') + 1))
      this.fileName = e.target.files[0].name
      fileReader.onload = (e) => {
        this.file = e.target.result
        this.$Progress.finish()
      }
    },
    fileChangeddtl (e) {
      this.$Progress.start()
      var fileReader = new FileReader()
      fileReader.readAsDataURL(e.target.files[0])
      this.fileSize = e.target.files[0].size / 1024
      this.fileExt = e.target.files[0].name.substr((e.target.files[0].name.lastIndexOf('.') + 1))
      this.fileName = e.target.files[0].name
      fileReader.onload = (e) => {
        this.file = e.target.result
        this.$Progress.finish()
      }
    },
    cekFile () {
      var hasil = true
      if (this.fileSize > 0) {
        this.fileValid = 'File ' + this.fileName
        if (this.fileSize > 800) {
          this.fileValid = this.fileValid + ' berukuran ' + Math.round(this.fileSize * 100) / 100 + ' Kb, max. 800 Kb. ' + '\n\r'
          hasil = false
        }
        // if (this.fileExt !== 'application/pdf') {
        //   this.fileValid = this.fileValid + 'File bukan pdf, ' + this.fileExt
        //   hasil = false
        // }
      }
      return hasil
    },
    upload ($event) {
      this.fileChanged($event)
      this.loadCSV($event)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/Pengajuan/Upload.vue?7b224402